<template>
  <Tooltip>
    <template #element>
      <span>
        Expertise
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Bewertung, wie gut die Methode dabei helfen kann den Status als Expert*in auszubauen
      </span>
    </template>
  </Tooltip>
</template>


<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
